import { formatLocation } from "./location.js";
export const transformLocationsToDropdownData = (locations) => {
    return locations.map((location) => {
        return {
            value: {
                isErrorMessage: false,
                isSelectedLocation: false,
                locationId: location.id,
            },
            title: formatLocation({
                suburb: location.suburb,
                state: location.stateCode ?? "",
                postcode: location.postcode,
            }),
        };
    });
};
